import { render, staticRenderFns } from "./TheTopbar.vue?vue&type=template&id=be1afe34&"
import script from "./TheTopbar.vue?vue&type=script&lang=js&"
export * from "./TheTopbar.vue?vue&type=script&lang=js&"
import style0 from "./TheTopbar.vue?vue&type=style&index=0&id=be1afe34&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports